import PropTypes from 'prop-types'

export const buttonType = PropTypes.shape({
	label: PropTypes.string.isRequired,
	link: PropTypes.string.isRequired,
})

export const imageType = PropTypes.any
